import React, { useState } from "react";
import styles from "./AddUser.module.scss";
import {useActions} from "../../../hook/useActions";
import {GetAllUsersAsync} from "../../../store/action-creators/userActions";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import type {AppDispatch} from "../../../store/store";

export default function AddUser() {
    const {AddUserAsync} = useActions();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const [form, setForm] = useState({
        fullName: "",
        recomendatorNumber: "",
        country: "",
        city: "",
        email: "",
        password: "",
        phoneNumber: ""
    });

    const handleChange = (e: any) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        // dispatch(AddUserAsync(form))
        //     .then(() => {
        //         dispatch(GetAllUsersAsync());
        //         navigate("/admin/users");
        //     })
        //     .catch((err) => {
        //         console.error("Failed to delete user:", err);
        //     });

        // try {
            await dispatch(AddUserAsync(form));
            await dispatch(GetAllUsersAsync());
        //     navigate("/admin/users");
        // }catch {}
        // catch (error) {
        //     console.error("Failed to add user:", error);
        //     alert("Failed to add user. Please try again.");
        //     return;
        // }
    };

    return (
        <div className={styles.container}>
            <h2>Add User</h2>
            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <label className={styles.label}>Full Name *</label>
                    <input
                        className={styles.input}
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Recomendator Number *</label>
                    <input
                        className={styles.input}
                        type="text"
                        name="recomendatorNumber"
                        value={form.recomendatorNumber}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Country *</label>
                    <input
                        className={styles.input}
                        type="text"
                        name="country"
                        value={form.country}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>City *</label>
                    <input
                        className={styles.input}
                        type="text"
                        name="city"
                        value={form.city}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Email *</label>
                    <input
                        className={styles.input}
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Password *</label>
                    <input
                        className={styles.input}
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Phone Number</label>
                    <input
                        className={styles.input}
                        type="text"
                        name="phoneNumber"
                        value={form.phoneNumber}
                        onChange={handleChange}
                    />
                </div>

                <button type="submit" className={styles.button}>
                    Add User
                </button>
            </form>
        </div>
    );
}
